import { Translate } from '@chipinside/translate'
import { IconButton, Stack, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { MouseEvent } from 'react'

import { ActionsProps, ImageActionKey } from '#/components/FormCall/Inputs/InputImage/types'
import { Icon } from '#/components/Icon'

const Wrapper = styled(Stack)({
  '&.bottom-left': {
    bottom: 8,
    left: 8,
  },
  '&.bottom-right': {
    bottom: 8,
    right: 8,
  },
  '&.top-left': {
    left: 8,
    top: 8,
  },
  '&.top-right': {
    right: 8,
    top: 8,
  },
  'backgroundColor': 'rgba(255, 255, 255, 0.9)',
  'border': '1px solid rgba(0, 0, 0, 0.1)',
  'borderRadius': 20,
  'padding': 2,
  'position': 'absolute',
  'zIndex': 1,
})

export const Actions = ({
  actions,
  disabled,
  onAction,
  position = 'top-right',
  sx,
}: ActionsProps) => {
  const handleClick = (key: ImageActionKey) => (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    onAction(key)
  }

  return (
    <Wrapper direction="row" spacing={0.5} sx={sx} className={position}>
      {actions.map(({ color, icon, key }) => (
        <Tooltip key={key} title={Translate({ messageKey: key })}>
          <span>
            <IconButton size="small" color={color} disabled={disabled} onClick={handleClick(key)}>
              <Icon size="small" name={icon} />
            </IconButton>
          </span>
        </Tooltip>
      ))}
    </Wrapper>
  )
}
